/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { OAuthClientDetailsModel } from '../../models/oauth/oauth-client-details-model';

export interface OAuthClientsGetParams {
    clientId: string;
}

export function oAuthClientsGet(http: HttpClient, rootUrl: string, params: OAuthClientsGetParams, context?: HttpContext): Observable<StrictHttpResponse<OAuthClientDetailsModel>> {
    const rb = new RequestBuilder(rootUrl, oAuthClientsGet.PATH, 'get');

    rb.path('clientId', params.clientId, { 'style': 'simple' });

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<OAuthClientDetailsModel>;
        })
    );
}

oAuthClientsGet.PATH = '/api/v1/oauth2/clients/{clientId}';
